(function () {
  window.addEventListener('DOMContentLoaded', () => {
    const View = {
      specialAccessories: document.getElementById('special-accessories'),
      relatedProducts: document.getElementById('related-products'),
      sisterProducts: document.getElementById('sister-products'),
      relatedItems: document.getElementById('related-items'),
      specialAccessoriesProductContainer: document.getElementById(
        'special-accessories-product-container'
      ),
      relatedProductsProductContainer: document.getElementById(
        'related-products-product-container'
      ),
      sisterProductsProductContainer: document.getElementById(
        'sister-products-product-container'
      ),

      hideSpecialAccessoriesSection: function () {
        this.specialAccessories.style.display = 'none';
      },
      hideRelatedProductsSection: function () {
        this.relatedProducts.style.display = 'none';
      },
      hideSisterProductSection: function () {
        this.sisterProducts.style.display = 'none';
      },
      showSpecialAccessoriesSection: function () {
        this.specialAccessories.style.display = 'block';
      },
      showRelatedProductsSection: function () {
        this.relatedProducts.style.display = 'block';
      },
      showSisterProductSection: function () {
        this.sisterProducts.style.display = 'block';
      },
    };

    const Model = {
      prevVariantId: '',
    };

    const Controller = {
      /**
       *
       * @param {{image_url: String, handle: string, title: string, has_basic_colors: boolean, min_price: number}[]} rawData
       * @returns
       */
      getProductListDOM(data = []) {
        const arrLength = data.length;
        let htmlRow = `<div class="grid product-list-container grid--2-col grid--4-col-tablet grid--5-col-desktop">`;
        for (let j = 0; j < arrLength; j++) {
          const cardData = {
            handle: data[j].handle,
            hasBasicColors: data[j].hasBasicColors,
            imgUrl: data[j].image_url,
            price: data[j].min_price,
            sale_price: data[j].sale_price,
            title: data[j].title
          }
          htmlRow +=  _Components.productCard(cardData);
        }
        htmlRow += `</div>`;

        var div = document.createElement('div');
        div.innerHTML = htmlRow.trim();

        return div.firstChild;
      },
      renderRelatedItems(variantId) {
        View.specialAccessoriesProductContainer.innerHTML = '';
        View.relatedProductsProductContainer.innerHTML = '';
        View.sisterProductsProductContainer.innerHTML = '';

        View.hideRelatedProductsSection();
        View.hideSisterProductSection();
        View.hideSpecialAccessoriesSection();

        fetch(mainPoint + 'related/' + variantId)
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            if (res?.error === 'no record found') {
              return;
            }
            return res;
          })
          .then((res) => {
            if (!res) return;

            const specialAccessories = res?.data?.special_accessories || [];
            const relatedProducts = res?.data?.related_products || [];
            const sisterProducts = res?.data?.sister_products || [];

            if (specialAccessories.length > 0) {
              View.showSpecialAccessoriesSection();
              View.specialAccessoriesProductContainer.appendChild(
                Controller.getProductListDOM(specialAccessories)
              );
            }

            if (relatedProducts.length > 0) {
              View.showRelatedProductsSection();
              View.relatedProductsProductContainer.appendChild(
                Controller.getProductListDOM(relatedProducts)
              );
            }

            if (sisterProducts.length > 0) {
              View.showSisterProductSection();
              View.sisterProductsProductContainer.appendChild(
                Controller.getProductListDOM(sisterProducts)
              );
            }
          })
          .then(() => {
            window?._Services?.favourite?.renderFavForCards();
          });
      },
      onVariationChange(newVariationId) {
        if (newVariationId !== Model.prevVariantId) {
          Model.prevVariantId = newVariationId;
          this.renderRelatedItems(newVariationId);
        }
      },
    };

    window._RelatedItems = {
      onVariationChange: Controller.onVariationChange.bind(Controller),
    };
  });
})();
